import Naluri from '~/common/api/naluri';
import { List } from 'immutable';
import {
  NOTES_GET_NOTES_BEGIN,
  NOTES_GET_NOTES_SUCCESS,
  NOTES_GET_NOTES_FAILURE,
  NOTES_GET_NOTES_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getNotes(channelID = '', pageNumber = 1) {
  return dispatch => {
    // optionally you can have getState as the second argument
    dispatch({
      type: NOTES_GET_NOTES_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = Naluri.get(`/api/expert/notes/${channelID}?page=${pageNumber}`);
      doRequest.then(
        res => {
          dispatch({
            type: NOTES_GET_NOTES_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        err => {
          dispatch({
            type: NOTES_GET_NOTES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetNotesError() {
  return {
    type: NOTES_GET_NOTES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case NOTES_GET_NOTES_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        listings: List(),
        getNotesPending: true,
        getNotesError: null,
      };

    case NOTES_GET_NOTES_SUCCESS:
      // The request is success
      const fetchedNotes = action.data.data;

      const pagination = action.data.pagination.filter(
        pageItem =>
          !pageItem.current &&
          pageItem.label !== 'Next' &&
          pageItem.label !== 'Previous' &&
          pageItem.label !== '0',
      );
      return {
        ...state,
        listings: List(fetchedNotes),
        totalPage: pagination.length + 1,
        currentPage: state.currentPage + 1,
        getNotesPending: false,
        getNotesError: null,
      };

    case NOTES_GET_NOTES_FAILURE:
      // The request is failed
      return {
        ...state,
        getNotesPending: false,
        getNotesError: action.data.error,
      };

    case NOTES_GET_NOTES_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getNotesError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/notes/redux/getNotes.js